export default {
  about: {
    title: '人脸检测',
    description: '检测图片或视频流中的人脸，支持针对检测出的人脸进行属性分析。',
    connect: '立即接入',
    consult: '功能咨询 >',
  },

  footer: {
    productTrial: '产品试用',
    contactMessage: '填写业务需求表格，我们将尽快联系您！',
    sendRequest: '把您的需求发给我们',
    businessCooperation: '商务合作',
    emailAddress: '邮箱地址',
    salesEmail: "qidi{'@'}quectel.com",
    partnerRecruitment: '生态伙伴招募',
    becomePartner: '成为合作伙伴',
    learnMore: '了解更多',
    logo: 'Quectel Algostore',
    slogan: '让AI检测更简单',
    products: '产品',
    oneStopTraining: '一站式训练平台',
    deviceOpenPlatform: '设备开放平台',
    aiModelMarket: 'AI 模型市场',
    developerTools: '开发者工具',
    solutions: '解决方案',
    smartRetail: '智慧零售',
    smartManufacturing: '智能制造',
    smartCity: '智慧城市',
    digitalFinance: '数字金融',
    contactUs: '联系我们',
    preSalesConsultation: '售前咨询',
    technicalSupport: '技术支持',
    support: '技术支持',
    helpDocumentation: '帮助文档',
    developerCommunity: '开发者社区',
    openSource: '移远开源',
    aboutUs: '关于我们',
    companyIntroduction: '公司介绍',
    news: '新闻动态',
    joinUs: '加入我们',
    aiTrainingPlatform: '上海移远通信有限公司 版权所有',
    other: '其他',
    cooperative: '合作咨询',
    aboutQuec: '关于移远',
    productServices: '产品与服务',
    module: '模组与天线',
    IOT: '物联网平台',
    download: '下载专区',
    forum: '技术论坛',
    partner: '合作伙伴',
    RD: '研发中心',
    PreSale: '售前咨询',
    cooperator: '合作咨询',
    company: '公司介绍',
    provide: '联系我们，Quectel Algostore持续为您提供解决方案咨询',
    or: '或',
    leave: '留下您的信息',
    message: '您的信息',
    developer: '开发者中心',
  },

  technologies: {
    imageDetection: '图像检测',
    imageDetectionDesc: '识别缺陷位置及数量',
    imageSegmentation: '图像分割',
    imageSegmentationDesc: '像素识别缺陷位置及轮廓',
    imageClassification: '图像分类',
    imageClassificationDesc: '适合整张图片分类',
    ocrDetection: 'OCR文字检测与识别',
    ocrDetectionDesc: '结构化输出文本内容',
    oneStopTrainingPlatform: '一站式训练平台',
    oneStopTrainingDesc:
      '支持包括数据采集、数据标注、模型训练、云边部署的开发流程，旨在帮助零基础用户开发场景化的智能算法',
    scenarioAI: '场景化AI需求',
    noAlgorithm: '零算法基础入门',
    oneStopModel: '一站式模型定制',
    enterOneStopPlatform: '进入一站式训练平台',
    experienceNow: '立即体验',
    learnMore: '了解更多',
  },

  platformSelect: {
    title: '平台选择',
    description: '选择适合您的平台',
    technicalStrengthTitle: '强大技术实力',
    technicalStrength: {
      algorithmLeading: '算法即服务',
      algorithmDescription:
        '开发者可通过可视化界面自由组合。内置自动超参调优引擎，模型训练效率提升5倍，支持从数据标注到部署的全流程自动化',
      safeStable: '安全稳定',
      safeStableDescription:
        '多年用户与场景经验沉淀，获取多项管理体系认证书。毫秒级处理速度，鲁棒性高，支持高并发承载与高可用性保证',
      wideApplication: '算力硬实力',
      wideApplicationDescription:
        '支持复杂模型本地推理。通过芯片级指令优化，实现视频流实时分析、多传感器数据融合等高负载任务零延迟响应',
      easyAccess: '模型效率革命',
      easyAccessDescription:
        '自研AI算法压缩引擎，推理速度提升8倍，功耗降低60%，赋能边缘设备实时智能响应',
    },
    items: {
      quickStart: {
        title: '快速上手',
        description: '无需编程经验，通过简单的操作即可完成模型训练。',
      },
      oneStopService: {
        title: '一站式服务',
        description: '从数据采集到模型部署，提供完整的解决方案。',
      },
      safeReliable: {
        title: '安全可靠',
        description: '数据安全加密，确保您的业务信息得到保护。',
      },
    },
  },

  news: {
    header: '公司动态',
    title1:
      '移远通信AI玩具整体解决方案全面升级：融合火山引擎RTC大模型，打造实时交互新体验',
    title2: '重磅！移远通信工业智能品牌宝维塔™及旗下核心产品、解决方案正式发布',
    title3:
      '移远通信边缘计算模组成功运行DeepSeek模型，以领先的工程能力加速端侧AI落地',
  },

  aiot: {
    title: 'AIoT产品',
    description: '自适应AI算法与模块化硬件设计，正重新定义万物互联的价值边界',
    product1: {
      name: 'MWC大模型，引领服务机器人创新',
      desc: '助力实现 "情景理解、知识融合、智能交互、自主决策、任务执行"等多种功能',
    },
    product2: {
      name: '智能、安全、高效，看移远如何助力割草机智能化升级',
      desc: '开发了智能割草机解决方案，高效、安全的割草体验',
    },
    product3: {
      name: 'SG560D 5G NR 系列智能模块',
      desc: '广泛应用在智能网关、CPE、MiFi、MID、PND、POS、路由器等行业和设备',
    },
  },

  homepage: {
    experienceTitle: '体验标题',
    captcha: '验证码',
    captchaRefresh: '刷新验证码',
    captchaInstructions: '请输入验证码',
    captchaRequired: '验证码是必填项',
    confirm: '确认',
    uploadImage: '上传图片',
    invalidImageFormat: '请上传JPG/PNG格式图片',
    imageTooLarge: '图片文件过大',
    imageSizeLimit: '请将图片大小控制在 2MB 内',
    tooFrequent: '操作过于频繁',
    pleaseTryAgain: '操作过于频繁，请稍后再试',
    noFaceDetected: '未检测到人脸',
    pleaseSelectAgain: '请确保上传图像包含人像，并确保人脸正视画面',
    customUpload: '自定义',
    analysis: '分析',
    isSamePerson: '是否是同一个人',
    isSamePet: '是否是同一个宠物',
    highProbability: '可能性较高',
    lowProbability: '可能性较低',
    uploadTip: '*请上传一张本地图片，体验功能。',
    title: '欢迎来到官网',
    experienceTitle: '功能体验',
    feature1: '支持多人脸识别',
    feature2: '识别高效准确',
    feature3: '支持实时检测',
    imageText: '我是图片',
    applicationTitle: '应用场景',
    application1: '考勤机',
    application2: '疲劳监测',
    analysis: '分析结果',
    cropText: '已检测到图中 {num} 张人脸，点击人脸图片查看结果信息！',
    serialNumber: '序列号',
    content: '内容',
    cropBodyText: '已检测到图中 {num} 个行人，点击图片查看结果信息',
    cropHumanBodyText: '已检测到图中 {num} 个人体，点击图片查看结果信息',
    noPetDetected: '未检测到宠物脸',
    pleasePetSelectAgain: '请重新选择，确保宠物脸正对画面',
    qrText: '已检测到图中 {num} 张二维码，点击图片查看结果信息',
    ocrText: '已检测到图中 {num} 张车牌，点击车牌图片查看结果信息',
    ocrWaterMeterText: '已检测到图中 {num} 张水表，点击水表图片查看结果信息',
    vehicleText: '已检测到图中 {num} 张车辆，点击图片查看结果信息',
    imageText: '已识别图中 {num} 张图片，点击图片查看结果信息',
    cropHandText: '已检测到图中 {num} 个手势，点击手势图片查看结果信息',
    cropMaskText: '已检测到图中 {num} 个口罩，点击图片查看结果信息',
    cropDriverText: '已检测到图中 {num} 个驾驶行为，点击图片查看结果信息',
    cropHelmetText: '已检测到图中 {num} 张结果图片，点击图片查看结果信息',
    imageFireText: '已识别图中 {num} 张火焰图片，点击图片查看结果信息',
    imageGestureText: '已识别图中 {num} 张手势图片，点击图片查看结果信息',
    imageVestText: '已识别图中 {num} 张结果图片，点击图片查看结果信息',
  },

  landmarks: {
    captcha: '验证码',
    captchaRefresh: '看不清',
    captchaInstruction: '请输入验证码',
    captchaRequired: '验证码是必填项',
    confirm: '确定',
    uploadImage: '本地上传图片',
    formatError: '请上传JPG/PNG格式图片',
    sizeError: '图片文件过大',
    sizeLimit: '请将图片大小控制在 2MB 内',
    frequentOperation: '操作过于频繁',
    tryAgain: '请稍后再试',
    noFaceDetected: '未检测到人脸',
    reselect: '请确保上传图像包含人像，并确保人脸正视画面',
    customUpload: '自定义',
    uploadTip: '*请上传一张本地图片，体验功能。',
    applicationTitle: '应用标题',
    application1: '应用内容1',
    characterCase: '输入下图中的字符，不区分大小写',
    notext: '未检测到文字',
    textReselect: '请重新选择，确保文字正对画面',
    live: '直播交互',
  },
  messages: {
    uploadImageFormat: '请上传 JPG/PNG 格式的图片',
    imageFileTooLarge: '图片文件过大',
    imageSizeLimit: '请将图片大小控制在 2MB 内',
    tooFrequentOperations: '操作过于频繁',
    tryAgainLater: '请稍后再试',
    noFaceDetected: '未检测到人脸',
    reselectImage: '请确保上传图像包含人像，并确保人脸正视画面',
    uploadLocalImage: '*请上传一张本地图片，体验功能。',
    passenger: '客流统计',
    serverBusy: '服务繁忙，请稍后再试',
  },
  buttons: {
    confirm: '确定',
    localUpload: '本地上传图片',
  },
  faceLandmarks: {
    title: '人脸关键点',
    description:
      '检测人脸五官与轮廓的关键点及位置，关键点包括人脸轮廓、眼睛、眉毛、嘴唇以及鼻子轮廓。',
  },
  recognition: {
    faceAge: {
      name: '年龄性别',
      dec: '我是年龄性别描述',
    },
    faceComparison: {
      name: '人脸对比',
      dec: '我是人脸对比描述',
    },
    faceGender: {
      name: '性别识别',
      dec: '我是性别识别描述',
    },
    faceEmotion: {
      name: '情绪识别',
      dec: '我是情绪识别描述',
    },
    petComparison: {
      name: '宠物对比',
      dec: '我是宠物对比描述',
    },
  },

  common: {
    yes: '是',
    no: '否',
    supportModule: '支持模组',
    board: '支持开发板',
    ecological: '智能生态开发板',
  },

  audio: {
    dec: '实时分离人声与环境噪音，毫秒级处理确保音质无损。适配会议、直播、录音等场景，保留人声细节，还原清晰音质，一键开启纯净声场',
  },
}
